import { LAB_MARKERS, type MarkerKey } from "./labRanges";
import { parseLocalDateKey } from "./dailyLogs";


export type LabUploadRow = {
  lab_date: string;
  [key: string]: any;
};

export type MarkerPoint = { date: number; value: number; unit: string };

export function groupByMarker(
  rows: LabUploadRow[],
): Record<MarkerKey, MarkerPoint[]> {
  const out = {} as Record<MarkerKey, MarkerPoint[]>;
  for (const m of LAB_MARKERS) {
    const valKey = `${m.key}_value`;
    const unitKey = `${m.key}_unit`;
    const points: MarkerPoint[] = [];
    for (const row of rows) {
      const v = row?.[valKey];
      if (v === null || v === undefined || v === "") continue;
      const num = Number(v);
      if (!Number.isFinite(num)) continue;
      // Parse YYYY-MM-DD as LOCAL midnight (not UTC) to avoid timezone drift
      // that previously rendered lab dates one day earlier in negative-UTC zones.
      const localDate = parseLocalDateKey(row.lab_date) || new Date(row.lab_date);
      const ts = localDate.getTime();
      if (!Number.isFinite(ts)) continue;

      points.push({ date: ts, value: num, unit: row?.[unitKey] || "" });
    }
    points.sort((a, b) => a.date - b.date);
    out[m.key] = points;
  }
  return out;
}

export function computeTrend(
  values: number[],
): "up" | "down" | "stable" | null {
  if (!Array.isArray(values) || values.length < 2) return null;
  if (values.length === 2) {
    const [a, b] = values;
    if (b >= 1.1 * a) return "up";
    if (b <= 0.9 * a) return "down";
    return "stable";
  }
  const last3 = values.slice(-3);
  const [a, b, c] = last3;
  const median = (a + b) / 2;
  if (median === 0) return "stable";
  if (c >= 1.1 * median) return "up";
  if (c <= 0.9 * median) return "down";
  return "stable";
}
